import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import {AzPageHeader} from '../../components/AzPageHeader'
import { PagesListWrapper } from './pages-list/PagesList';
import { useIntl } from 'react-intl';

const PagesPage = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='Pages'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'PAGE.TITLE' })} />
              <PagesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/pages-management/pages' />} />
    </Routes>
  );
};

export default PagesPage;